import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";
import imageCompression from "browser-image-compression";

export const fetchAllShopping = createAsyncThunk(
  "shopping/fetchAllShopping",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/shoppingOption`);

      // console.log(response.data.data)
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // The server returns 404 when there is no data
        return [];
      }

      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

export const AddShopping = createAsyncThunk(
  "shopping/AddShopping",
  async ({ data }, { rejectWithValue }) => {
    try {
      // console.log(selectedSuperCategoryId)
      // console.log("🚀 Starting AddBrand function...");

      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();

      formData.append("title_en", data.nameEn);
      formData.append("title_ar", data.nameAr);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `category-${Date.now()}.webp`);
      }

      // console.log("🧾 Sending Category with FormData...");

      const createResponse = await axios.post(
        `${BASE_URL}/shoppingOption`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token,
          },
        }
      );

      return createResponse.data.data;
    } catch (error) {
      console.error("AddCategory failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to add Category");
    }
  }
);

export const deleteShoppingById = createAsyncThunk(
  "shopping/deleteShoppingById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(`${BASE_URL}/shoppingOption/${id}`, {
        headers: {
          token: token,
        },
      });

      // console.log("✅ Category deleted:", response.data);

      // Can we return the id to update the state in the reducer?
      return id;
    } catch (error) {
      console.error("Delete failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to delete Category"
      );
    }
  }
);

export const updateShoppingById = createAsyncThunk(
  "shopping/updateShoppingById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();
      formData.append("title_en", data.nameEn);
      formData.append("title_ar", data.nameAr);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `category-${Date.now()}.webp`);
      }

      const response = await axios.put(
        `${BASE_URL}/shoppingOption/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: token,
          },
        }
      );

      return response.data.updatedShopping || response.data;
    } catch (error) {
      console.error("Update failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to update Shopping"
      );
    }
  }
);

const shoppingSlice = createSlice({
  name: "shopping",
  initialState: {
    allShopping: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllShopping.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllShopping.fulfilled, (state, action) => {
        state.loading = false;
        state.allShopping = action.payload; 
      })
      .addCase(fetchAllShopping.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default shoppingSlice.reducer;

// Export actions and reducer
